import TipTapEditor from "src/components/TipTapEditor/TipTapEditor";
import { FLASHCARDS_TOOLBAR_FEATURES } from "src/components/TipTapEditor/TipTapToolbar";

interface FlashcardsTipTapEditorProps {
	initialHtml?: string;
	onUpdate?: (html: string) => void;
	onSubmit?: (html: string) => void | Promise<void>;
	submitText?: string;
	cancelText?: string;
	onCancel?: () => void;
	placeholder?: string;
	className?: string;
	error?: string;
	helperText?: string;
	hideActionsWhenClean?: boolean;
	label?: string;
	"data-test-id"?: string;
}

// Edytor TipTap z okrojonym paskiem narzędzi dla fiszek:
// najpierw edycja tekstu (pogrubienie/kursywa/przekreślenie/kolor), potem listy i zdjęcia.
export function FlashcardsTipTapEditor(props: FlashcardsTipTapEditorProps) {
	return (
		<TipTapEditor
			{...props}
			features={FLASHCARDS_TOOLBAR_FEATURES}
			inlineFirst
		/>
	);
}
